<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2" sm="12" cols="12">
            <Sidebar></Sidebar>
        </v-col>
        <v-col md="10" sm="12" cols="12">
            <h1 class="headline">Download Historical Materials</h1>
            <FilterableDataTable :headers="headers"
                                 :items="items"
                                 item-key="DocumentId"
                                 :items-per-page="50"
                                 loading-text="Loading... Please wait"
                                 class="elevation-1"
                                 disablePagination
                                 hideDefaultFooter
                                 style="table-layout: fixed;">
                <template v-slot:item.Title="{ item }">
                    <a @click.stop="Download(item.DocumentId)">{{item.Title}}.pdf</a>
                </template>
            </FilterableDataTable>
        </v-col>
    </v-row>
</template>
<script>
    import { mdiMagnify } from '@mdi/js';
    const Sidebar = () => import("@/Menus/Sidebar.vue");
    const FilterableDataTable = () => import("@/Components/FilterableDataTable.vue");

    export default {
        name: 'HistoricalDowloads',
        components: {
            FilterableDataTable, Sidebar
        },
        methods: {
            LoadData()
            {
                this.loading = true;
                fetch('/api/Historical/Downloads',
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            return res.text().then(r => Promise.reject(r));
                    })
                    .then(response =>
                    {
                        response = EncodeDatetimes(response);
                        this.items = response;

                    })
                    .catch(error =>
                    {
                        throw new Error(error);
                    })
                    .finally(_ =>
                    {
                        this.loading = false;
                    });
            },
            async Download(documentId)
            {
                await fetch('/api/SessionLaws/Token/' + documentId,
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" }
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            return res.text().then(r => Promise.reject(r));
                    })
                    .then(r =>
                    {
                        window.location.assign(r.url);
                    });
            }
        },
            data: function ()
            {
                return {
                    searchIcon: mdiMagnify,
                    search: '',
                    loading: false,
                    headers: [
                        {
                            text: 'Title',
                            value: 'Title',
                            align: 'left',
                            width: '*',
                            sortable: true,
                            visible: true,
                            filterable: true,
                        },

                    ],
                    items: [],
                }
            },
            mounted: function ()
            {
                this.LoadData();
            },
            watch: {
            },
            computed: {
                Title: function ()
                {
                    let title = 'Historical Downloads';
                    return title;
                },
                Description: function ()
                {
                    return this.Title;
                }
            },
            metaInfo()
            {
                return {
                    title: this.Title,
                    meta: [
                        { vmid: 'description', name: 'description', content: this.Description },
                        // OpenGraph data (Most widely used)
                        { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                        // The list of types is available here: http://ogp.me/#types
                        { vmid: 'og:type', property: 'og:type', content: 'website' },
                        // Should be the same as your canonical link, see below.
                        { vmid: 'og:url', property: 'og:url', content: window.location.href },
                        // Often the same as your meta description, but not always.
                        { vmid: 'og:description', property: 'og:description', content: this.Description },

                        // Twitter card
                        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                        { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                        { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                        { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                    ],
                    link: [
                        { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                    ]
                }
            }
        };
</script>
<style></style>